const DEFAULT_API_URL =
  process.env.NODE_ENV === "production"
    ? "https://autowork-be-7eba6ac8292f.herokuapp.com"
    : "http://localhost:3000";

export const ADMIN_PASSWORD_STORAGE_KEY = "adminPassword";

export const getAdminApiUrl = () =>
  process.env.REACT_APP_API_URL || DEFAULT_API_URL;

export const getAdminHeaders = (withJson = false) => {
  const token = localStorage.getItem("userAccessToken");
  const storedAdminPassword = localStorage.getItem(ADMIN_PASSWORD_STORAGE_KEY);
  const adminPassword =
    storedAdminPassword ||
    process.env.REACT_APP_ADMIN_PASSWORD ||
    process.env.ADMIN_PASSWORD;

  return {
    ...(withJson ? { "Content-Type": "application/json" } : {}),
    ...(adminPassword ? { "X-Admin-Password": adminPassword } : {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
};

export async function adminFetch(path, options = {}) {
  const headers = {
    ...getAdminHeaders(Boolean(options.body)),
    ...(options.headers || {}),
  };
  const response = await fetch(`${getAdminApiUrl()}${path}`, {
    ...options,
    headers,
  });
  const result = await response.json().catch(() => ({}));

  if (!response.ok || result.success === false) {
    throw new Error(
      result.message || result.error || `Admin API error: ${response.status}`
    );
  }

  return result;
}
